import styles from './buy-preview.module.scss';
import PreviewWrapper from '@components/shared/header/nav-previews/preview-wrapper/preview-wrapper';
import Link from 'next/link';

import { Themes } from '@layouts/main-layout/themes.enum';
import { BuyPreviewState } from '../../../nav-state/buy-preview.state';
import { ReactSVG } from 'react-svg';
import { Dispatch, SetStateAction } from 'react';
import { useTranslations } from 'next-intl';

type BuyPreviewProps = {
  theme: Themes;
  onMenuClicked?: () => void
};

const BuyPreview = ({ theme, onMenuClicked }: BuyPreviewProps) => {
  const t = useTranslations();
  const { cards } = BuyPreviewState;

  const themedClasses = (classes: string) => `${classes} ${styles[theme]}`;
  const arrowIconSrc = '/layout-images/header/icons/chevron-right.svg';

  return (
    <PreviewWrapper theme={theme}>
      <div className={themedClasses(styles.cards)}>
        {cards.map((card, key) => (
          <div key={key} className={styles.cards__default} style={{ minWidth: card.colWidth }}>
            <Link scroll={false} href={card.href} passHref legacyBehavior>
              <div className={styles.cards__title__wr}>
                <ReactSVG style={{ maxWidth: '32px', maxHeight: '32px' }} src={card.iconSrc} />
                <h4 className={styles.cards__title}>{t(card.title)}</h4>
                <ReactSVG style={{ maxWidth: '16px', maxHeight: '16px' }} src={arrowIconSrc} />
              </div>
            </Link>

            <div className={styles.cards__body}>
              {card.links.map((link, key) => (
                <Link key={key} href={link.href} legacyBehavior>
                  <a onClick={onMenuClicked} className={themedClasses(styles.cards__link)}>
                    <span>{t(link.title)}</span>
                  </a>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PreviewWrapper>
  );
};

export default BuyPreview;
